import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import List from "../../assets/image/List.svg";
import "./Header.css";
import { useTranslation } from "react-i18next";
import { getUserData } from "../../store/actions/user.action";
import HeaderDropDownMenu from "../General/HeaderDropDownMenu";

import ImpersonateUserModal from "../Dialog/ImpersonateUserModal";

function Header(props) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.user.currentUser);
  const [openImpersonate, setOpenImpersonate] = useState(false);

  let parsedUserProfile;
  try {
    if (
      userProfile &&
      typeof userProfile === "string" &&
      userProfile.trim() !== ""
    ) {
      parsedUserProfile = JSON.parse(userProfile);
    } else {
      parsedUserProfile = userProfile;
    }
  } catch (error) {
    console.error("Error parsing userProfile JSON:", error);
    parsedUserProfile = {};
  }

  let isAdmin = false;
  try {
    let userData = parsedUserProfile;
    if (!userData || (!userData.is_staff && !userData.is_superuser)) {
      const stored = localStorage.getItem("userData");
      if (stored) userData = JSON.parse(stored);
    }
    if (userData && (userData.is_staff || userData.is_superuser)) {
      isAdmin = true;
    }
  } catch (e) {
    console.error("Error checking admin status in Header", e);
  }

  const addBodyClass = (className) => document.body.classList.add(className);
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  useEffect(() => {
    dispatch(getUserData({ token }));
  }, [dispatch, token]);

  return (
    <div className="header">
      <div className="flex items-center gap-6 2xl:gap-10 h-16">
        <div className="lingoMark mr-auto">
          <Link to="/" className="break-keep select-none flex items-center gap-2">
            <img
              className="w-[130px] 2xl:w-[150px] h-14 object-contain"
              src="https://res.cloudinary.com/do6t8sxgo/image/upload/v1753753120/logo_lingclub_ydu5pu.png"
              alt="main-logo"
            />
          </Link>
        </div>
        <div className="navBar hidden lg:flex items-center order-2 lg:order-1 lg:w-auto">
          <HeaderDropDownMenu />
        </div>
        {token === null && (
          <div className="hidden lg:flex items-center gap-2 order-3">
            <Link
              to="/login"
              className="px-5 py-2 rounded-full border-[1.5px] border-[var(--brand)] text-[var(--brand)] font-semibold text-sm hover:bg-[var(--brand)] hover:text-white transition-all"
            >
              {t("header.login")}
            </Link>
            <Link
              to="/register"
              className="px-5 py-2 rounded-full bg-[var(--brand)] text-white font-semibold text-sm shadow-[0_4px_14px_rgba(108,99,255,.3)] hover:bg-[var(--brand-dark)] hover:-translate-y-[1px] transition-all"
            >
              {t("header.register")}
            </Link>
          </div>
        )}
        {token === null ? (
          <button className="lg:hidden" onClick={props.openMenu}>
            <img src={List} alt="Menu" className="w-8" />
          </button>
        ) : (
          <div className="flex items-center gap-2 order-1 lg:order-2">
            {isAdmin && (
              <button
                onClick={() => setOpenImpersonate(true)}
                className="px-3 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-600 text-white font-semibold text-xs flex items-center gap-1 shadow-sm transition-all"
                title="Impersonate User"
              >
                <span>👤</span>
                <span className="hidden sm:inline">Impersonate</span>
              </button>
            )}
            <button
              onClick={() => {
                props.openMenu();
                addBodyClass("overflow-hidden");
              }}
            >
              <img
                src={
                  parsedUserProfile?.image
                    ? `${parsedUserProfile.image}`
                    : "https://res.cloudinary.com/do6t8sxgo/image/upload/v1724686661/Nobody_bao3i5.svg"
                }
                alt="UserImage"
                className="border-2 rounded-full border-[var(--brand)] h-[42px] w-[42px] object-cover"
              />
            </button>
          </div>
        )}
      </div>
      <ImpersonateUserModal
        open={openImpersonate}
        handleClose={() => setOpenImpersonate(false)}
      />
      <div className="flex justify-end py-1 gap-1.5 flex-wrap">
        {[
          { code: "en", label: "English" },
          { code: "cn", label: "中文" },
          { code: "es", label: "Español" },
        ].map((lang) => (
          <button
            key={lang.code}
            onClick={() => {
              i18n.changeLanguage(lang.code);
              setSelectedLanguage(lang.code);
              localStorage.setItem("selectedLanguage", lang.code);
            }}
            className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
              selectedLanguage === lang.code
                ? "bg-[var(--brand)] text-white"
                : "bg-transparent text-[var(--muted)] border border-[var(--border)] hover:border-[var(--brand)] hover:text-[var(--brand)]"
            }`}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Header;
